<template>
    <div>
        <veui-dialog
            :open="show"
            ui="auto"
            overlay-class="vip-authorize-modal"
            @cancel="cancel"
        >
            <div slot="title" class="header">
                <div class="title">
                    {{
                        isAuthorized
                            ? "授权成功"
                            : "开通会员可享13大律临权益"
                    }}
                </div>
                <div class="subTitle">
                    {{
                        isAuthorized
                            ? "您已授权律临运营人员主动联系您沟通律临会员产品权益事宜，请您保持手机畅通，我们将尽快联系您，感谢您对律临的信任！"
                            : "当前会员限时优惠中，更有额外惊喜等你来，快点击下方按钮，让律临专业客服为您介绍权益细则"
                    }}
                </div>
            </div>
            <div slot="foot" class="footer">
                <veui-button
                    ui="l" class="btn"
                    @click="handleClick"
                >
                    {{
                        isAuthorized ? "好的" : "授权客服电联，了解更多会员权益"
                    }}
                </veui-button>
            </div>
        </veui-dialog>
    </div>
</template>
<script>
/**
 * @file vip授权引导弹窗
 * @author xingminghua
 */
import {mapState} from 'vuex';
import {Dialog, Button} from 'veui';

export default {
    components: {
        'veui-dialog': Dialog,
        'veui-button': Button
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
        authorized: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState({
            passInfo: state => state.lawStore?.userInfoNew?.pass_info || {}
        })
    },
    watch: {
        authorized: {
            immediate: true,
            handler(newVal) {
                this.isAuthorized = newVal;
            }
        }
    },
    data() {
        return {
            isAuthorized: false
        };
    },
    methods: {
        cancel() {
            this.$emit('cancel');
        },
        handleClick() {
            // 授权
            if (!this.isAuthorized) {
                this.$http
                    .post('/bp/api/vip/genvip', {
                        name: this.passInfo.pass_name
                    })
                    .then(res => {
                        if (+res?.code === 0) {
                            this.isAuthorized = true;
                        }
                        else {
                            this.$normalizeResponseError(res);
                        }
                    });
            }
            // 关闭
            else {
                this.$wywLog.send({
                    serverId: 17078,
                    action: 'click',
                    area: 'authorize-dialog-btn'
                });
                this.cancel('dialog_btn');
            }
        }
    }
};
</script>
<style lang='less' scoped>
.vip-authorize-modal {
    /deep/ .veui-dialog-content {
        width: 420px;
        padding: 0;
        overflow: hidden;
        background-image: linear-gradient(180deg, #FACBA2 -24.21%, #FFF 17.37%);
        position: relative;
        .veui-dialog-content-head {
            background-color: transparent;
            position: relative;
            padding: 30px;
            .veui-dialog-content-head-close {
                position: absolute;
                top: 27px;
                right: 27px;
            }
        }
        .veui-dialog-content-body {
            padding: 2px 20px;
        }
        .veui-dialog-content-foot {
            padding: 0;
        }
    }
    .header {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        .icon {
            margin-bottom: 3px;
            width: 120px;
            height: 110px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .title {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #000000;
            font-weight: 500;
            margin-bottom: 24px;
            text-align: center;
        }
        .subTitle {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #000000;
            line-height: 22px;
            font-weight: 400;
            text-align: center;
        }
    }
    .footer {
        padding: 0 30px 30px;
        .btn {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            background-color: #FED9B9;
            color: #401611;
            font-weight: 700;
            width: 100%;
            height: 40px;
        }
    }
}
</style>